import React from 'react';

const getStyle = (cell) => {
  let style = {};
  if (cell.width) {
    style.minWidth = `${cell.width}px`;
  }
  if (cell.sticky) {
    style.position = 'sticky';
    style.left = cell.left;
  }

  if (cell.style) {
    style = {...style, ...cell.style};
  }

  return style;
};

const Header = ({columns, className}) => (
  <thead>
    <tr className={className || ''}>
      {columns.map((column, index) => (
        <th
          style={getStyle(column)}
          className={column.className || column.headcolumClass}
          {...column.style}
          key={index}
        >
          {column.headerName}
        </th>
      ))}
    </tr>
  </thead>
);

export default Header;
